<!--
 * @Author: zhonghao
 * @Date: 2023-07-05 22:10:25
-->
<template>
  <div class="index-details">
    <div class="index-title">{{detailsConten.title}}</div>
    <div class="index-date">{{detailsConten.create_time}}</div>
    <div class="index-con" v-html="detailsConten.content">
    </div>
  </div>
</template>
<script>

import { getSigelInfo } from '@/api/person'
export default {
  name: 'wineDetails',
  data () {
    return {
      detailsConten: {}
    }
  },
  created () {
    getSigelInfo({ id: this.$route.query.id }).then(res => {
      this.detailsConten = res.data
    })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.index-details {
  width: 100vw;
  min-height: 100vh;
  background-color: #1E2020;
  padding: 30px 20px;
  box-sizing: border-box;
  .index-title {
    font-size: 26px;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 36px;
    margin-bottom: 20px;
  }
  .index-date {
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .index-con {
    color: #FFFFFF;
    font-size: 16px;
    line-height: 28px;
    /deep/ img {
      width: 100%!important;
      display: block!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/singlePage.vue